"use client";

import { atom } from "jotai";

// Tracks IDs of currently open overlays (dialogs, alert dialogs, etc.)
export const overlayOpenIdsAtom = atom<Set<string>>(new Set<string>());

// Derived: whether any overlay is open
export const isAnyOverlayOpenAtom = atom((get) => get(overlayOpenIdsAtom).size > 0);

// Write-only atom to register/unregister an overlay open state
export const setOverlayOpenAtom = atom(
  null,
  (get, set, payload: { id: string; open: boolean }) => {
    const next = new Set(get(overlayOpenIdsAtom));
    if (payload.open) {
      next.add(payload.id);
    } else {
      next.delete(payload.id);
    }
    set(overlayOpenIdsAtom, next);
  },
);
